/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ProductType {
    Unknown = 0,
    Cladding = 1,
    Frame = 2,
    RoofLight = 3,
    RoofTrim = 4,
    RoofOverhang = 5,
    FrameHeader = 6,
    DrainPipe = 7,
    Faucet = 8,
}
